// extracted by mini-css-extract-plugin
export default {"formContainer":"ReportForm_formContainer__mojHa","reportTable":"ReportForm_reportTable__4CqV0","onSubmit":"ReportForm_onSubmit__Chn9R"};